import * as C from "@sp-crm/core";
import { ContactId, IPlacement, parseEntityId, PlacementId } from "@sp-crm/core";
import { BridgeQuestionShim } from "components/questions/bridge-question-shim";
import * as React from "react";
import { connect } from "react-redux";
import { Action, Dispatch } from "redux";
import { createChangeRegionAction } from "store/actions/region";
import { getClient } from "store/selectors/selectors";
import { usersArrayForCurrentRegion } from "store/selectors/users";
import { ApplicationState } from "store/state";
import { AdvancedSearchEntityType, CommunityOrdering } from "../../../generated/graphql";
import * as actions from "../../../store/actions";
import {
    loadClient,
    updateClient,
    updateClientAnswer,
    updateClientMultiField,
    updateClientPromise,
} from "../../../store/actions";
import {
    getShareLink,
    reactivateClient,
    updateClientCommunityOrder,
} from "../../../store/actions/clients";
import { loadLeafElementsForEntity } from "../../../store/actions/entity";
import { SingleUserState } from "../../../store/reducers/user";
import { UserState } from "../../../store/reducers/users";
import { ShowClient, Subpage } from "./index";

type ViewState = "loading" | "viewable";

interface ShowClientFromRouteOwnProps {
    clientId: PlacementId;
    activeSubpage: string;
}

interface ShowClientFromRoutePropsFromState {
    placement: IPlacement;
    users: C.User[];
    user: C.User;
    viewState: ViewState;
    now: Date;
    pdfRenderable: boolean;
    tenant: C.ITenant;
    fileCount: number;
    newlyAddedContactPerson?: ContactId;
    selectedRegionId: C.RegionId | null;
}

interface ShowClientFromRoutePropsFromDispatch {
    onUpdateAnswer: (placementId: PlacementId, answer: C.IAnswer) => void;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- eslintintroduction
    onFieldChange: (clientId: PlacementId, fieldName: string, newValue: any) => void;
    onFieldChangePromise: (
        clientId: PlacementId,
        fieldName: string,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any -- eslintintroduction
        newValue: any,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any -- eslintintroduction
    ) => Promise<any>;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- eslintintroduction
    onMultiFieldChange: (clientId: PlacementId, newValues: any) => void;
    triggerClientLoad: (id: string) => void;
    navigate: (path: string) => void;
    reactivate: () => void;
    getShareLink: () => Promise<string>;
    onClientCommunityOrderChange: (
        clientId: PlacementId,
        ordering: CommunityOrdering[],
    ) => void;
    changeRegion: (regionKey: string) => void;
}

type ShowClientFromRouteProps = ShowClientFromRoutePropsFromState &
    ShowClientFromRoutePropsFromDispatch &
    ShowClientFromRouteOwnProps;

class ShowClientFromRoute extends React.Component<ShowClientFromRouteProps, undefined> {
    UNSAFE_componentWillMount() {
        this.props.triggerClientLoad(this.props.clientId);
    }

    componentDidUpdate(prevProps: ShowClientFromRouteProps): void {
        if (
            this.props.selectedRegionId &&
            this.props.placement &&
            this.props.viewState === "viewable" &&
            this.props.placement.regionId &&
            this.props.placement.regionId !== this.props.selectedRegionId &&
            (this.props.placement.regionId !== prevProps.placement?.regionId ||
                this.props.selectedRegionId !== prevProps.selectedRegionId ||
                this.props.viewState !== prevProps.viewState)
        ) {
            this.props.changeRegion(this.props.placement.region);
        }
    }

    onFieldChange(fieldName: string, newValue: string): void {
        this.props.onFieldChange(this.props.clientId, fieldName, newValue);
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- eslintintroduction
    onFieldChangePromise(fieldName: string, newValue: string): Promise<any> {
        return this.props.onFieldChangePromise(this.props.clientId, fieldName, newValue);
    }

    onMultiFieldChange(newValues: string): void {
        this.props.onMultiFieldChange(this.props.clientId, newValues);
    }

    onUpdateAnswer(answer: C.IAnswer) {
        this.props.onUpdateAnswer(this.props.clientId, answer);
    }

    activeSubpage(): Subpage {
        if (this.props.activeSubpage) {
            if (this.props.activeSubpage == "overview") return "overview";
            if (this.props.activeSubpage == "needs") return "needs";
            if (this.props.activeSubpage == "communities") return "communities";
            if (this.props.activeSubpage == "tasks") return "tasks";
            if (this.props.activeSubpage == "compareCommunities")
                return "compareCommunities";
            if (this.props.activeSubpage == "files") return "files";
            if (this.props.activeSubpage == "invoices") return "invoices";
            if (this.props.activeSubpage == "referrals") return "referrals";
            if (this.props.activeSubpage == "emailsSent") return "emailsSent";
            if (this.props.activeSubpage == "history") return "history";
        }
        return null;
    }

    selectSubpage(section: Subpage) {
        this.props.navigate(`/clients/show/${this.props.clientId}/${section}`);
    }

    closeSection() {
        this.props.navigate(`/clients/show/${this.props.clientId}`);
    }

    delete(navigateTo: string) {
        this.props.onFieldChange(this.props.clientId, "deleted", true);
        this.props.navigate(navigateTo);
    }

    navigateToClients() {
        this.props.navigate("/clients");
    }

    navigateToPrintIntakeForm() {
        this.props.navigate(`/clients/intake`);
    }

    showClient(): JSX.Element {
        const client = (
            <BridgeQuestionShim
                entityName={AdvancedSearchEntityType.Client}
                regionKeys={[this.props.placement.region]}>
                {questions => (
                    <ShowClient
                        key={`show-client-${this.props.placement.id}`}
                        placement={this.props.placement}
                        onFieldChange={(n, v) => this.onFieldChange(n, v)}
                        onFieldChangeMulti={v => this.onMultiFieldChange(v)}
                        newlyAddedContactPerson={this.props.newlyAddedContactPerson}
                        onUpdateAnswer={answer => this.onUpdateAnswer(answer)}
                        onClientCommunityOrderChange={
                            this.props.onClientCommunityOrderChange
                        }
                        delete={this.delete.bind(this)}
                        questions={questions}
                        users={this.props.users}
                        user={this.props.user}
                        tenant={this.props.tenant}
                        now={this.props.now}
                        activeSubpage={this.activeSubpage()}
                        selectSection={(section: Subpage) => this.selectSubpage(section)}
                        closeSection={() => this.closeSection()}
                        pdfRenderable={this.props.pdfRenderable}
                        fileCount={this.props.fileCount}
                        reactivate={this.props.reactivate}
                        getShareLink={this.props.getShareLink}
                        navigateToClients={() => this.navigateToClients()}
                        navigateToPrintIntakeForm={() => this.navigateToPrintIntakeForm()}
                        triggerClientLoad={this.props.triggerClientLoad}
                    />
                )}
            </BridgeQuestionShim>
        );
        return <span>{client}</span>;
    }

    render() {
        if (this.props.viewState == "viewable") {
            return this.showClient();
        } else if (this.props.viewState == "loading") {
            return <div>Loading...</div>;
        } else {
            return <div>Sorry, we&apos;ve encountered an error. Please reload.</div>;
        }
    }
}

function mapDispatchToProps(
    dispatch: Dispatch<Action>,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- eslintintroduction
    ownProps: any,
): ShowClientFromRoutePropsFromDispatch {
    const clientId: PlacementId = ownProps.clientId;
    const val = {
        triggerClientLoad: (placementId: PlacementId) => {
            loadClient(placementId, dispatch);
            loadLeafElementsForEntity(placementId, dispatch);
        },
        // eslint-disable-next-line @typescript-eslint/no-explicit-any -- eslintintroduction
        onFieldChange: (placementId: PlacementId, fieldName: string, newValue: any) => {
            updateClient(placementId, fieldName, newValue, dispatch);
        },
        onFieldChangePromise: (
            placementId: PlacementId,
            fieldName: string,
            // eslint-disable-next-line @typescript-eslint/no-explicit-any -- eslintintroduction
            newValue: any,
        ) => {
            return updateClientPromise(placementId, fieldName, newValue, dispatch);
        },
        // eslint-disable-next-line @typescript-eslint/no-explicit-any -- eslintintroduction
        onMultiFieldChange: (placementId: PlacementId, newValues: any) => {
            updateClientMultiField(placementId, newValues, dispatch);
        },

        onUpdateAnswer: (placementId: PlacementId, answer: C.IAnswer) => {
            updateClientAnswer(placementId, answer, dispatch);
        },
        navigate: (path: string) => {
            actions.navigate(path);
        },
        reactivate: () => {
            reactivateClient(clientId, dispatch);
        },
        getShareLink: () => {
            return getShareLink(clientId, dispatch);
        },
        onClientCommunityOrderChange: (
            placementId: PlacementId,
            ordering: CommunityOrdering[],
        ) => {
            updateClientCommunityOrder(placementId, ordering, dispatch);
        },
        changeRegion: (regionKey: string) => {
            dispatch(createChangeRegionAction(regionKey));
        },
    };
    return val;
}

function mapStateToProps(
    state: ApplicationState,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- eslintintroduction
    ownProps: any,
): ShowClientFromRoutePropsFromState {
    const placementId = parseEntityId<PlacementId>(ownProps.clientId);
    const allUsers = (state.users as UserState).users;
    const loggedInUserId = (state.userState as SingleUserState).userId;
    const users = usersArrayForCurrentRegion(state);
    const user = allUsers[loggedInUserId];
    const clientState = state.clients;
    let placement: IPlacement = null;
    let viewState: ViewState = "loading";
    if (clientState.loading.find(x => x === placementId)) {
        viewState = "loading";
    }
    if (
        clientState.clients[placementId] &&
        clientState.fullyLoadedClients.find(x => x === placementId)
    ) {
        placement = getClient(state, placementId);
        viewState = "viewable";
    }

    let fileCount = 0;
    if (state.files.files && state.files.files[placementId]) {
        fileCount = state.files.files[placementId].length;
    }

    const newlyAddedContactPerson = state.selectedContacts.selections[placementId];

    if (!placement) {
        viewState = "loading";
    }

    return {
        placement: placement,
        users,
        user,
        viewState,
        now: state.time.now,
        pdfRenderable: true,
        tenant: state.tenant.tenant,
        fileCount,
        newlyAddedContactPerson,
        selectedRegionId:
            state.region.regions.find(r => r.key === state.region.selectedRegion)?.id ||
            null,
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(ShowClientFromRoute);
